import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, Validators } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { SitesAreaService } from "../../services/sites-area.service";
import { Site } from "@shared/models/site";
import { User } from "@shared/models/user/user";
import { UsersComponent } from "@features/settings/users/components/users/users.component";
import { MatDialog } from "@angular/material/dialog";
import { SiteModaleComponent } from "../site-modal/site-modal.component";
import { Country } from "@shared/models/country";
import { ConfirmDialogComponent } from "@shared/components/confirm-dialog/confirm-dialog.component";
import { WorkingStatusEnum } from "@shared/models/working-status-enum";
import { CurrentStateService } from "app/core/services/current-state.service";
import { DeviceConfigComponent } from "@shared/components/device-config/device-config.component";
import { DeviceConfigService } from "@shared/services/config/device-config.service";
import { AlarmConfigurationComponent } from "@shared/components/alarm-configuration/alarm-configuration.component";

@Component({
    standalone: true,
    selector: 'app-site-details',
    templateUrl: './site-details.component.html',
    styleUrls: ['./site-details.component.scss'],
    imports: [CommonModule, FormsModule,MatIconModule, TranslateModule,AngularSvgIconModule,UsersComponent,DeviceConfigComponent, AlarmConfigurationComponent
    ],
})
export class SiteDetailsComponent implements OnInit{
    siteId: number | null = null;
    site: Site | null = null;
    users: User[] = [];
    error: string | null = null;
    tab: number = 1;
    protected countries: Country[] | undefined;
    paysName: string | undefined;
    deviceConfigForm: FormGroup;
    isDeviceConfigChanged = false;
    initialDeviceConfigValue: any;
  constructor(private route: ActivatedRoute,private router: Router,
    private sitesAreaService: SitesAreaService, private dialogConfirme: MatDialog, private fb: FormBuilder,
    private currentStateService: CurrentStateService, private deviceConfigService: DeviceConfigService,
  ) {}
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
        this.siteId = +params['siteId'] || null;
        this.getSiteById(this.siteId);
        this.loadDeviceConfiguration();
        this.initDeviceConfigForm();
      });
      
}

    getSiteById(siteId: number): void {
        this.sitesAreaService.getSiteById(siteId).subscribe(result => {
            this.site = result;
            this.sitesAreaService.countries$.subscribe(countries => {
                this.countries = countries;
                this.paysName = this.countries.find(country => country.paysId === this.site?.paysId)?.nom;
              });
        });
    }
    backToEventList(): void {
        this.router.navigate(['/settings']);
      }

    openPopupSite(siteId: number | null, regionId: number): void {
        const dialogRef = this.dialogConfirme.open(SiteModaleComponent,
        {
            data: { isNew: siteId ? false : true, regionId: regionId , countries : null, regions: null , siteId: siteId},
            enterAnimationDuration: '0ms',
        },);
        dialogRef.afterClosed().subscribe(() => {
            this.getSiteById(this.siteId);
        });
    }
    changerTab(numTab: number) {
        if (numTab == 1) {
          this.tab = 1;
        } else if (numTab == 2) {
          this.tab = 2;
        }
        else
          this.tab = numTab;
      }

    deleteSite(siteId: number): void {
        this.sitesAreaService.deleteSite(siteId).subscribe(() => {
            this.backToEventList();
        });
    }      
    onDelete(siteId: number) {
        const dialogRef = this.dialogConfirme.open(ConfirmDialogComponent, {
        enterAnimationDuration: '0ms',
        data: { title: 'Delete Site', message: 'Would you like to delete this site ?' },
        });
        dialogRef.afterClosed().subscribe(result => {
        if (result) {
        this.deleteSite(siteId);
            }
        });
    } 
  onDeviceConfigFormReady(form: FormGroup) {
    this.deviceConfigForm = form;
  }
    initDeviceConfigForm() {
      this.deviceConfigForm = this.fb.group({
        id: [null],
        receivedDate: [new Date()],
        recTime: [1, [Validators.required, Validators.min(1), Validators.max(32)]],
        recMode: [WorkingStatusEnum.NO_REC, Validators.required],
        preTrg: [0, [Validators.required, Validators.min(0), Validators.max(500)]],
        trgVib: [0.1, [Validators.required, Validators.min(0.1), Validators.max(200)]],
        trgSnd: [94, [Validators.required, Validators.min(74), Validators.max(140)]],
        tmrUse: [false],
        tmrStartTime: ['00:00'],
        tmrEndTime: ['23:59'],
        activeDays: [0, [Validators.min(0), Validators.max(127)]],
        uploadInterval: [0, [Validators.min(0), Validators.max(60)]],
        realTUse: [false],
        trgUseVib: [true],
        trgUseSnd: [true],
        redAlertValue: [null],
        yellowAlertValue: [null],
        orangeAlertValue: [null],
        siteId: [null]
      });
      this.initialDeviceConfigValue = this.deviceConfigForm.getRawValue();
      this.deviceConfigForm.valueChanges.subscribe(() => {
        this.isDeviceConfigChanged = JSON.stringify(this.deviceConfigForm.value) !== JSON.stringify(this.initialDeviceConfigValue);
      });
    }

    async loadDeviceConfiguration() {
    if (!this.siteId) {
      return;
    }
    try {
      this.currentStateService.setShowLoading(true);
      const deviceConfig = await this.deviceConfigService.getDeviceConfiguration(null, this.siteId).toPromise();
      console.log(deviceConfig);
      
      if (deviceConfig) {
        const startTime = deviceConfig.tmrStartTime ? this.formatTimeForInput(deviceConfig.tmrStartTime) : '00:00';
        const endTime = deviceConfig.tmrEndTime ? this.formatTimeForInput(deviceConfig.tmrEndTime) : '23:59';
        const { emailsThreshold, ...rest } = deviceConfig;
        this.deviceConfigForm.patchValue({
          ...rest,
          trgSnd: rest.trgSnd != null ? parseFloat((20 * Math.log10(rest.trgSnd / 20e-6)).toFixed(1)) : 94,
          tmrStartTime: startTime,
          tmrEndTime: endTime
        });        
        const emailsArray = this.deviceConfigForm.get('emailsThreshold') as any;
        emailsArray.clear();
        (emailsThreshold || []).forEach((email: any) => {
          emailsArray.push(this.fb.group({
            id: [email.id],
            thresholdId: [email.thresholdId],
            email: [email.email],
            isActive: [email.isActive],
            alarm: [email.alarm],
            configId: [email.configId]
          }));
        });
        this.initialDeviceConfigValue = this.deviceConfigForm.getRawValue();
      }
    } catch (error) {
      // ...error handling...
    } finally {
      this.currentStateService.setShowLoading(false);
    }
  }
    private formatTimeForInput(timeString: string): string {
    if (!timeString) return '00:00';
    if (timeString.match(/^\d{2}:\d{2}$/)) {
      return timeString;
    }
    const time = new Date(`1970-01-01T${timeString}`);
    if (!isNaN(time.getTime())) {
      return time.toTimeString().substring(0, 5);
    }
    return '00:00';
  }
}